import React from "react";
import { useForm } from "react-final-form";
import {
  InstrumentSelectField,
  InstrumentTypeSelectField,
} from "@syos-music/instruments";

import { Grid } from "@mui/material";

export default function OptionsField({ name }) {
  const form = useForm();
  const instrument = form.getFieldState(`${name}.instrument`)?.value;

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <InstrumentSelectField name={`${name}.instrument`} required />
      </Grid>

      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          key={instrument}
          instrument={instrument}
          name={`${name}.${instrument}Type`}
          required
        />
      </Grid>
    </Grid>
  );
}
